import { render, staticRenderFns } from "./HoistingDetail.vue?vue&type=template&id=66c648f9&scoped=true&"
import script from "./HoistingDetail.vue?vue&type=script&lang=js&"
export * from "./HoistingDetail.vue?vue&type=script&lang=js&"
import style0 from "./HoistingDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HoistingDetail.vue?vue&type=style&index=1&id=66c648f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c648f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c648f9')) {
      api.createRecord('66c648f9', component.options)
    } else {
      api.reload('66c648f9', component.options)
    }
    module.hot.accept("./HoistingDetail.vue?vue&type=template&id=66c648f9&scoped=true&", function () {
      api.rerender('66c648f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/HoistingDetail.vue"
export default component.exports